module.exports = __webpack_public_path__ + "static/media/w-2_31.bc2e0e68.png";